import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ModalsDisplayStoreState {
  journeySupportPromotion: {
    lastDateShown: Date;
    timesShown: number;
    stopShowing?: boolean;
  };
  hasSeenTestosteroneLabsNotification: boolean;

  markJourneySupportPromotionAsSeen: (opts?: { stopShowing?: boolean }) => void;
  markTestosteroneLabsNotificationAsSeen: (seen: boolean) => void;
}

export const useModalsDisplayStore = create<ModalsDisplayStoreState>()(
  persist(
    (set, get) => ({
      hasSeenTestosteroneLabsNotification: false,
      journeySupportPromotion: {
        lastDateShown: new Date(),
        timesShown: 0,
        stopShowing: false,
      },

      markJourneySupportPromotionAsSeen: (opts) =>
        set({
          journeySupportPromotion: {
            lastDateShown: new Date(),
            timesShown: get().journeySupportPromotion.timesShown + 1,
            stopShowing: opts?.stopShowing,
          },
        }),

      markTestosteroneLabsNotificationAsSeen: (
        hasSeenTestosteroneLabsNotification,
      ) => set({ hasSeenTestosteroneLabsNotification }),
    }),
    {
      name: "modals-display",
    },
  ),
);
